import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import Slider from "react-slick";
import Wishlisted from "../property/Wishlisted";
import { showPrice } from '../../utils/showPrice';
import { formatDate } from '../../utils/formatDate';
import { avgPrice } from '../../utils/avgPrice';
import dummyImg from '../../images/no-image-thumb.jpg'
import generateSlug from '../common/generateSlug';
import AlertModal from '../modals/AlertModal';
const TopProjects = ({ topProjects, wishlist, user, token, handleDispatch }) => {

  const [isVisible, setIsVisible] = useState(window.innerWidth <= 991);
   const [showAlertModal, setShowAlertModal] = useState(false);
  const handleOpenModal = () => {
  setShowAlertModal(true);

  // Auto close after 2 seconds
  setTimeout(() => {
    setShowAlertModal(false);
  }, 1500);
};

  useEffect(() => {
    const handleResize = () => {
      setIsVisible(window.innerWidth <= 991);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  const PrevArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button
        className={`custom-arrow custom-prev`}
        onClick={onClick}
      >
        {"<"}
      </button>
    );
  };

  const NextArrow = (props) => {
    const { className, onClick } = props;
    return (
      <button
        className={`custom-arrow custom-next`}
        onClick={onClick}
      >
        {">"}
      </button>
    );
  };
  const settings = {
    dots: false,
    infinite: false,

    speed: 1000,
    slidesToShow: 1, // Default: Show 3 slides
    slidesToScroll: 1,
    autoplay: false,
    fade: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          centerMode: false,
          slidesToShow: 1, // Show only 1 slide when screen width is 991px or smaller
          slidesToScroll: 1,

        },
      },
    ],
  };


  const handleLinkClick = (project) => {


    // let url = '';
    // url = `/${project?.property_service}-pid-${project.project_id}`

const url = generateSlug(project);


    const propertyIds = project?.property_ids;

    //   navigate(url, { state: { propertyIds }, replace: true });
    localStorage.setItem('last-property-seen', JSON.stringify({ id: propertyIds, typeWithId: url }))

    window.location.href = url; // Navigate manually
  };


  return (
    <>
      {topProjects?.length > 0 && (
        <>
          <section className="spot-section sectiontopgap mob">


            <div className="sectiontitle">
              <div className="titleunderline" data-aos='fade-right'>
                <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
                </svg>

              </div>
              <h1>Top Rated Projects in Jaipur  {'mob'}</h1>
            </div>

            <div className='content content_margin'>
              <div className="container">


                <Slider {...settings}>
                  {topProjects?.length > 0 && (
                    topProjects?.map((project, index) => (
                      <div className={`topproslides spotslide${index + 1}`} key={index} onClick={() => handleLinkClick(project)}>



                        <div className="proimgbox" style={{ backgroundImage: `url(${project.property_image[0]?.image || dummyImg})` }}>
                          
                          <div className='topdatabx'>
                            <div className='share-whislist'><Wishlisted data={project} wishlist={wishlist} user={user} token={token} handleDispatch={handleDispatch} themeValue={'light'} handleOpenModal={handleOpenModal} /></div>
                            <h4 className="absoprice">{showPrice(project?.pricing)}</h4>
                          </div>


                          
                          <div className='botdatabx'>  
                              <h4>{project?.project_name}</h4>
                              <p>By {project?.builder_name}</p>                                  
                              <p className='botloc'>
                                <svg width="15" height="15" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.74442 12L2.57471 13.8242C2.18716 13.9938 2.17217 14.538 2.5498 14.7287L8.82003 17.8939C8.9531 17.9611 9.1092 17.9654 9.24576 17.9057L16.499 14.7324C16.9066 14.554 16.8958 13.9721 16.4817 13.8091L11.8873 12" stroke="white" stroke-linecap="round"/>
                                <path d="M9.5 0.945312C7.13889 0.945312 5.25 2.8342 5.25 5.19531C5.25 7.55642 9.5 14.1675 9.5 14.1675C9.5 14.1675 13.75 7.55642 13.75 5.19531C13.75 2.8342 11.8611 0.945312 9.5 0.945312ZM9.5 7.0842C8.46111 7.0842 7.61111 6.2342 7.61111 5.19531C7.61111 4.15642 8.46111 3.30642 9.5 3.30642C10.5389 3.30642 11.3889 4.15642 11.3889 5.19531C11.3889 6.2342 10.5389 7.0842 9.5 7.0842Z" fill="white"/>
                                </svg>
                                &nbsp;
                                {project?.locality_name}, {project?.city_name}
                              </p>
                          </div>  
                          
                        </div>


                        {/* <div className='row'>
                          <div className='col-md-4 '>
                            <div className="proimgbox" style={{ backgroundImage: `url(${project.property_image[0]?.image})` }}>
                              <div className='share-whislist'>

                                <Wishlisted data={project} wishlist={wishlist} user={user} token={token} handleDispatch={handleDispatch} themeValue={'light'} />
                              </div>
                            </div>
                          </div>
                          <div className='col-md-8  ps-0'>
                            <div className="topprodata">
                              <div className="protop">

                                <div className="builderlogo">
                                  {project.builder_logo ? (
                                    <img
                                      src={`${project.builder_logo}`}
                                      alt="Project Logo"
                                      style={{ width: "75px", height: "75px", objectFit: "contain" }}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'flex';
                                      }}
                                    />
                                  ) : null}
                                  <div className='projectFirstLetterHome' style={{ display: project.builder_logo ? 'none' : 'flex' }}>
                                    {project.project_name ? project.project_name.charAt(0).toUpperCase() : ''}
                                  </div>
                                </div>

                                <div className="protpbox">
                                  <div className="protitle">
                                    <h4>{project?.project_name}</h4>
                                    <p>By {project?.builder_name}</p>
                                  </div>
                                  <div className="proprice">
                                    <p>- Starting from</p>
                                    <h4>
                                      <svg width="1.84rem" height="1.84rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 3.75V5.25H9C10.2773 5.25 11.9561 6.0293 12.5391 7.5H6V9H12.7266C12.4951 10.957 10.4795 12 9 12H6V13.8516L13.6875 20.25H16.0312L7.92188 13.5H9C11.4258 13.5 14.0068 11.707 14.2266 9H18V7.5H14.1094C13.8809 6.6123 13.3945 5.85352 12.75 5.25H18V3.75H6Z" fill="white" />
                                      </svg>

                                      {showPrice(project?.pricing)}

                                    </h4>
                                  </div>
                                </div>
                              </div>

                              <div className="promid">

                                <div className='toplocicon'>
                                  <p className="prolocation">
                                    <svg width="18" height="18" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.74247 12L2.57276 13.8242C2.18521 13.9938 2.17021 14.538 2.54785 14.7287L8.81808 17.8939C8.95114 17.9611 9.10724 17.9654 9.24381 17.9057L16.497 14.7324C16.9047 14.554 16.8938 13.9721 16.4798 13.8091L11.8853 12" stroke="#F68633" stroke-linecap="round" />
                                      <path d="M9.5 0.945312C7.13889 0.945312 5.25 2.8342 5.25 5.19531C5.25 7.55642 9.5 14.1675 9.5 14.1675C9.5 14.1675 13.75 7.55642 13.75 5.19531C13.75 2.8342 11.8611 0.945312 9.5 0.945312ZM9.5 7.0842C8.46111 7.0842 7.61111 6.2342 7.61111 5.19531C7.61111 4.15642 8.46111 3.30642 9.5 3.30642C10.5389 3.30642 11.3889 4.15642 11.3889 5.19531C11.3889 6.2342 10.5389 7.0842 9.5 7.0842Z" fill="#F68633" />
                                    </svg>
                                    <span>
                                      {project?.locality_name}, {project?.sub_locality_name}
                                    </span>
                                  </p>

                                  <div className='top-icons'>
                                    <Wishlisted data={project} wishlist={wishlist} user={user} token={token} handleDispatch={handleDispatch} themeValue={'light'} />
                                  </div>
                                </div>

                                <p className='project_description'>{project?.project_description}</p>
                              </div>


                              <div className='row specimobht' style={{ textTransform: 'capitalize' }}>
                                {project?.project_area && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Project Area</p>
                                      <p className='proj-value'>{project.project_area} Sq.Ft.</p>
                                    </div>
                                  </div>
                                )}

                                {project?.sizes?.length > 0 && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Sizes</p>
                                      <p className='proj-value'>
                                        {project.sizes.length > 1
                                          ? `${project.sizes[0]} - ${project.sizes[project.sizes.length - 1]}`
                                          : project.sizes[0]} Sq.ft.
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {project?.configurations && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Configurations</p>
                                      <p className='proj-value'>
                                        {project.configurations} {['villa', 'apartment'].includes(project.property_type) ? ` BHK ${project.property_type} ` : ''}
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {project?.launch_date && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Launch Date</p>
                                      <p className='proj-value'>{formatDate(project.launch_date, "MM-YYYY")}</p>
                                    </div>
                                  </div>
                                )}

                                {project?.possession_date && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Possession Starts</p>
                                      <p className='proj-value'>{formatDate(project.possession_date, "MM-YYYY")}</p>
                                    </div>
                                  </div>
                                )}

                                {project?.pricing && project?.sizes?.length > 0 && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Average Price</p>
                                      <p className='proj-value'>
                                        <i className="fa fa-rupee"></i>
                                        {avgPrice(project.pricing, project.sizes)}
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {project?.project_rera_id && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Rera Id</p>
                                      <p className='proj-value'>{project.project_rera_id}</p>
                                    </div>
                                  </div>
                                )}
                              </div>



                            </div>
                          </div>
                        </div> */}

                      </div>
                    ))
                  )}
                </Slider>

              </div>
            </div>

          </section>
          <section className="spot-section sectiontopgap desk">


            <div className="sectiontitle">
              <div className="titleunderline" data-aos='fade-right'>
                <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
                </svg>

              </div>
              <h1>Top Rated Projects in Jaipur  {isVisible}</h1>
            </div>

            <div className='content content_margin'>
              <div className="container">

                <Slider {...settings}>
                  {topProjects?.length > 0 && (
                    topProjects?.map((project, index) => (
                      <div className={`topproslides spotslide${index + 1}`} key={index} onClick={() => handleLinkClick(project)}>

                        <div className='row'>
                          <div className='col-md-4 '>
                            <div className="proimgbox" style={{ backgroundImage: `url(${project.property_image[0]?.image})` }}>
                              <div className='share-whislist'>

                                <Wishlisted data={project} wishlist={wishlist} user={user} token={token} handleDispatch={handleDispatch} themeValue={'light'} handleOpenModal={handleOpenModal}  />
                              </div>
                            </div>
                          </div>
                          <div className='col-md-8  ps-0'>
                            <div className="topprodata">
                              <div className="protop">

                                <div className="builderlogo">
                                  {project.builder_logo ? (
                                    <img
                                      src={`${project.builder_logo}`}
                                      alt="Project Logo"
                                      style={{ width: "75px", height: "75px", objectFit: "contain" }}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.style.display = 'none';
                                        e.target.nextSibling.style.display = 'flex';
                                      }}
                                    />
                                  ) : null}
                                  <div className='projectFirstLetterHome' style={{ display: project.builder_logo ? 'none' : 'flex' }}>
                                    {project.project_name ? project.project_name.charAt(0).toUpperCase() : ''}
                                  </div>
                                </div>

                                <div className="protpbox">
                                  <div className="protitle">
                                    <h4>{project?.project_name}</h4>
                                    <p>By {project?.builder_name}</p>
                                  </div>
                                  <div className="proprice">
                                    <p>- Starting from</p>
                                    <h4>
                                      <svg width="1.84rem" height="1.84rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 3.75V5.25H9C10.2773 5.25 11.9561 6.0293 12.5391 7.5H6V9H12.7266C12.4951 10.957 10.4795 12 9 12H6V13.8516L13.6875 20.25H16.0312L7.92188 13.5H9C11.4258 13.5 14.0068 11.707 14.2266 9H18V7.5H14.1094C13.8809 6.6123 13.3945 5.85352 12.75 5.25H18V3.75H6Z" fill="white" />
                                      </svg>

                                      {showPrice(project?.pricing)}

                                    </h4>
                                  </div>
                                </div>
                              </div>

                              <div className="promid">

                                <div className='toplocicon'>
                                  <p className="prolocation">
                                    <svg width="18" height="18" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.74247 12L2.57276 13.8242C2.18521 13.9938 2.17021 14.538 2.54785 14.7287L8.81808 17.8939C8.95114 17.9611 9.10724 17.9654 9.24381 17.9057L16.497 14.7324C16.9047 14.554 16.8938 13.9721 16.4798 13.8091L11.8853 12" stroke="#F68633" stroke-linecap="round" />
                                      <path d="M9.5 0.945312C7.13889 0.945312 5.25 2.8342 5.25 5.19531C5.25 7.55642 9.5 14.1675 9.5 14.1675C9.5 14.1675 13.75 7.55642 13.75 5.19531C13.75 2.8342 11.8611 0.945312 9.5 0.945312ZM9.5 7.0842C8.46111 7.0842 7.61111 6.2342 7.61111 5.19531C7.61111 4.15642 8.46111 3.30642 9.5 3.30642C10.5389 3.30642 11.3889 4.15642 11.3889 5.19531C11.3889 6.2342 10.5389 7.0842 9.5 7.0842Z" fill="#F68633" />
                                    </svg>
                                    <span>
                                      {project?.locality_name}, {project?.city_name}
                                    </span>
                                  </p>

                                  <div className='top-icons'>
                                    <Wishlisted data={project} wishlist={wishlist} user={user} token={token} handleDispatch={handleDispatch} themeValue={'light'} />
                                  </div>
                                </div>

                                <p className='project_description'>{project?.project_description}</p>
                              </div>


                              <div className='row specimobht' style={{ textTransform: 'capitalize' }}>
                                {project?.project_area && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Project Area</p>
                                      <p className='proj-value'>{project.project_area}</p>
                                    </div>
                                  </div>
                                )}

                                {project?.sizes?.length > 0 && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Sizes</p>
                                      <p className='proj-value'>
                                        {project.sizes.length > 1
                                          ? `${project.sizes[0]} - ${project.sizes[project.sizes.length - 1]}`
                                          : project.sizes[0]} Sq.ft.
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {project?.configurations && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Configurations</p>
                                      <p className='proj-value'>
                                        {project.configurations} {['villa', 'apartment'].includes(project.property_type) ? ` BHK ${project.property_type} ` : ''}
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {project?.launch_date && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Launch Date</p>
                                      <p className='proj-value'>{formatDate(project.launch_date, "MM-YYYY")}</p>
                                    </div>
                                  </div>
                                )}

                                {project?.possession_date && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Possession Starts</p>
                                      <p className='proj-value'>{formatDate(project.possession_date, "MM-YYYY")}</p>
                                    </div>
                                  </div>
                                )}

                                {project?.pricing && project?.sizes?.length > 0 && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Average Price</p>
                                      <p className='proj-value'>
                                        <i className="fa fa-rupee"></i>
                                        {avgPrice(project.pricing, project.sizes)}
                                      </p>
                                    </div>
                                  </div>
                                )}

                                {project?.project_rera_id && (
                                  <div className='col-md-3 col-6'>
                                    <div className='prop-project'>
                                      <p className='proj-key'>Rera Id</p>
                                      <p className='proj-value'>{project.project_rera_id}</p>
                                    </div>
                                  </div>
                                )}
                              </div>



                            </div>
                          </div>
                        </div>

                      </div>
                    ))
                  )}
                </Slider>



              </div>
            </div>

          </section>
           {showAlertModal && 
      
        <AlertModal />
      }
        </>
      )}
    </>
  );
};

export default TopProjects;
